<div class="rechtstext">
  <h1>Widerrufsbelehrung</h1>
  <p>Verbraucher haben das Recht, einen Vertrag unter den folgenden Bedingungen zu widerrufen.</p>

  <h2>Widerrufsrecht</h2>
  <p>Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
  <p>Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.</p>

  <h2>Ausübung des Widerrufsrechts</h2>
  <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns</p>
  <p>
    IT-Service Karsten Fischer<br />
    Martinshof 2, 88410 Bad Wurzach<br />
    Telefon: +49 (0)7568 30 90 137<br />
    E-Mail: <a href="mailto:info@it-karsten-fischer.de">info@it-karsten-fischer.de</a>
  </p>
  <p>
    mittels einer eindeutigen Erklärung (z. B. per E-Mail oder Brief) über Ihren Entschluss
    informieren, diesen Vertrag zu widerrufen.
  </p>
  <p>
    Zur Wahrung der Frist reicht es aus, dass Sie die Mitteilung über die Ausübung des
    Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
  </p>

  <h2>Folgen des Widerrufs</h2>
  <p>
    Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle Zahlungen, die wir von Ihnen
    erhalten haben, unverzüglich und spätestens binnen 14 Tagen ab dem Tag, an dem die Mitteilung
    über Ihren Widerruf bei uns eingegangen ist.
  </p>
  <p>
    Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
    Transaktion eingesetzt haben, es sei denn, es wurde ausdrücklich etwas anderes vereinbart.
  </p>

  <h2>Besonderer Hinweis bei Dienstleistungen</h2>
  <p>
    Haben Sie verlangt, dass wir mit der Erbringung der Dienstleistungen während der Widerrufsfrist
    beginnen sollen, so haben Sie uns einen angemessenen Betrag zu zahlen.
  </p>
  <p>
    Dieser Betrag entspricht dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns über den Widerruf
    unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der vertraglich
    vorgesehenen Dienstleistungen.
  </p>

  <h2>Erlöschen des Widerrufsrechts</h2>
  <p>
    Das Widerrufsrecht erlischt, wenn die Dienstleistung vollständig erbracht wurde und mit der
    Ausführung der Dienstleistung erst begonnen wurde, nachdem Sie ausdrücklich zugestimmt haben und
    gleichzeitig Ihre Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger
    Vertragserfüllung verlieren.
  </p>

  <h2>Muster-Widerrufsformular</h2>
  <p>
    Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es
    zurück.
  </p>
  <p>
    An IT-Service Karsten Fischer, Martinshof 2, 88410 Bad Wurzach, E-Mail:
    info@it-karsten-fischer.de:<br /><br />
    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die Erbringung der
    folgenden Dienstleistung (*)<br />
    _________________________________<br /><br />
    Bestellt am (*)<br />
    _________________________________<br /><br />
    Name des/der Verbraucher(s)<br />
    _________________________________<br /><br />
    Anschrift des/der Verbraucher(s)<br />
    _________________________________<br /><br />
    Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)<br />
    _________________________________<br /><br />
    Datum<br />
    _________________________________
  </p>
  <p class="leise">(*) Unzutreffendes streichen.</p>

  <p class="stand">Ende der Widerrufsbelehrung</p>
</div>
